import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import style from './Input.module.scss';

const Input = ({
  label,
  error,
  enableEyeIcon,
  showIcon = false,
  imageIconUrl = '',
  ...rest
}) => {
  const className = 'c-Input';
  const inputEleClassname = [
    className,
    style[className],
    error ? style[`${className}__error`] : null,
  ].join(' ');

  const inputRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  useEffect(() => {
    if (!enableEyeIcon) return;
    if (showPassword) {
      // @ts-ignore
      inputRef.current.type = 'text';
    }
    // @ts-ignore
    else inputRef.current.type = 'password';
  }, [showPassword, enableEyeIcon]);

  return (
    <div>
      {label && (
        <p className={`${className}__label ${style[`${className}__label`]}`}>
          {label}
        </p>
      )}
      <div className={style[`${className}__wrapper`]}>
        {enableEyeIcon && (
          <div
            className={style[`${className}__visibility`]}
            onClick={toggleShowPassword}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </div>
        )}
        {showIcon && imageIconUrl && (
          <img
            className={style[`${className}__icon`]}
            src={imageIconUrl}
            alt="channel"
          />
        )}
        <input className={inputEleClassname} ref={inputRef} {...rest} />
      </div>
      {error && (
        <p
          className={`${className}__errorText ${
            style[`${className}__errorText`]
          }`}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
